/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_AlignInputs */



/**
* | output |
* | --- |
* | "Align" |
*
* @param {Editor_Table_Column_AlignInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_align = /** @type {((inputs?: Editor_Table_Column_AlignInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_AlignInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausrichten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выровнять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("整列")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संरेखित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhar")
	return /** @type {LocalizedString} */ ("Align")
});